module.exports = __webpack_public_path__ + "img/light-gray-right-arrow.1ec2eaa3.svg";